/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Index_TitleInputs */

const en_legal_index_title = /** @type {(inputs: Legal_Index_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sections`)
};

const lv_legal_index_title = /** @type {(inputs: Legal_Index_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sadaļas`)
};

/**
* | output |
* | --- |
* | "Sections" |
*
* @param {Legal_Index_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const legal_index_title = /** @type {((inputs?: Legal_Index_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Index_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_legal_index_title(inputs)
	return en_legal_index_title(inputs)
});